module.exports = __webpack_public_path__ + "img/qq.ed3fc4f4.svg";